export default "__VITE_ASSET__T$$boQW8__"